import { Injectable } from "@angular/core";
import * as crypto from "crypto-js";

@Injectable({
	providedIn: "root",
})
export class CryptoService {
	key: "7cfd0d16-05e6-4991-8d2f-4ed05ff39255-5de3172d-12dd-49f4-88da-d7115396a5f7";

	constructor() {}

	public async decrypt(data: any): Promise<any> {
		const bytes = crypto.AES.decrypt(data, this.key);
		return JSON.parse(bytes.toString(crypto.enc.Utf8));
	}

	public async encrypt(data: any): Promise<any> {
		return crypto.AES.encrypt(JSON.stringify(data), this.key).toString();
	}
}
